import { Link, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth'
import { SignOutIcon } from './components/Icons'
import { DashboardPage } from './pages/DashboardPage'
import { DeleteAccountPage } from './pages/DeleteAccountPage'
import { DisclaimerPage } from './pages/DisclaimerPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { PrivacyPage } from './pages/PrivacyPage'
import { ProfilePage } from './pages/ProfilePage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { RunPage } from './pages/RunPage'
import { SignInPage } from './pages/SignInPage'

export function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  )
}

function Shell() {
  const { user, loading, signOut } = useAuth()

  if (loading) {
    return (
      <div className="shell">
        <div className="spinner">Checking your session…</div>
      </div>
    )
  }

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <Logo />
          My Tracker
        </div>
        {user && (
          <div className="topbar-right">
            <Link to="/profile">{user.displayName}</Link>
            <button type="button" onClick={signOut}>
              <SignOutIcon />
              Sign out
            </button>
          </div>
        )}
      </header>

      {user ? (
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/runs/:id" element={<RunPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          {/* Someone already signed in has no use for these; send them to their runs. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (
        /*
         * Signed out still needs real routes, not just the sign-in form: a reset link arrives as
         * /reset-password?token=… and has to render that page for someone who by definition
         * cannot sign in. Anything else falls through to the form.
         */
        <Routes>
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          {/* Public on purpose: Google Play requires the deletion URL to open without an
              account, so it explains the process and offers a way in. */}
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="*" element={<SignInPage />} />
        </Routes>
      )}
    </div>
  )
}

/**
 * The app mark, identical to public/favicon.svg and to the Android launcher icon. The runner is
 * the same artwork the phone app's splash screen uses; the transform mirrors it in x and fits it
 * to this 32-unit canvas.
 */
function Logo() {
  return (
    <svg width="26" height="26" viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="7" fill="#0B1220" />
      <g transform="matrix(-0.3218,0,0,0.3218,28.4498,5.75)" fill="#38E07B">
        <path d="m 23.926,12.752 c 3.47,-0.402 5.963,-3.572 5.564,-7.082 -0.396,-3.51 -3.532,-6.029 -7,-5.628 -3.47,0.402 -5.961,3.572 -5.564,7.082 0.395,3.51 3.53,6.029 7,5.628 z" />
        <path d="M 60.258,57.826 C 55.348,49.395 40.077,22.155 37.542,17.709 c 4.949,-1.597 9.471,-0.139 13.027,4.899 2.892,4.098 9.656,0.169 6.729,-3.979 C 50.416,8.879 40.152,6.458 29.877,12.628 29.447,12.885 27.522,13.961 27.088,14.222 20.697,18.057 14.763,17.331 10.329,11.049 7.434,6.95 0.67,10.881 3.598,15.028 c 5.659,8.014 13.601,11.072 21.957,8.481 2.62,4.552 5.109,9.187 7.499,13.866 -3.533,1.825 -6.805,4.103 -9.846,6.781 -1.796,1.583 -1.501,3.659 -0.295,5.058 0.292,0.638 9.585,6.565 13.61,9.009 4.319,2.624 8.237,-4.194 3.934,-6.807 -2.602,-1.579 -5.202,-3.16 -7.803,-4.741 2.505,-1.707 8.94,-4.523 9.281,-4.795 3.862,6.646 7.732,13.282 11.595,19.924 2.542,4.376 9.281,0.411 6.728,-3.978 z" />
      </g>
      <g stroke="#38E07B" strokeWidth="1.5" strokeLinecap="round">
        <path d="M4.2 11.4h4.2" />
        <path d="M3.2 16h3.6" />
        <path d="M4.2 20.6h4.2" />
      </g>
    </svg>
  )
}
